

@if (!hasChildrens) {
  <div >
    <ul class="menu-links">
      <li [pTooltip]=" flagSidebar ? menuItem.text : '' "  [ngClass]="{'margin-li': menuItem.menuFatherId != null}" class="nav-link">
        <a (click)="onNavigate(menuItem.action)" href="javascript:void(0)">
          <i style="font-size: 18px !important;"  [ngClass]="{'collapsed-icon-children':  isChildren}" class="{{menuItem.icon}}  icon" ></i>
          <span style="margin-right: 30px;" [ngClass]="{'view-text': menuItem.menuFatherId != null}" class="text nav-text">{{menuItem.text}}</span>
        </a>
      </li>
    </ul>
  </div>
} @else {
  <ul  class="menu-links">
    <li [pTooltip]=" flagSidebar ? menuItem.text : '' " [ngClass]="{ 'margin-li': menuItem.menuFatherId != null, 'collapsed': menuItem.isCollapsed }" (click)="collapeMenu()" class="nav-link">
      <a (click)="onAccion()" href="javascript:void(0)">
        <i [ngClass]="{'collapsed-icon': menuItem.isCollapsed || isChildren}"  class="{{menuItem.icon}}  icon" ></i>
        <span  class="text nav-text" [ngClass]="{'collapsed-label': menuItem.isCollapsed ,'view-text': menuItem.menuFatherId != null}">{{menuItem.text}}</span>
        <i [ngClass]="{'collapsed-icon': menuItem.isCollapsed || isChildren}"  style="margin-left: auto; font-size: 15px; font-weight: 700;" [ngClass]="{'view-icon': menuItem.menuFatherId != null}" [class]="!flagSidebar ? (isIconUp ? 'bx bx-chevron-down' : 'bx bx-chevron-up') : (isIconUp ? 'bx bx-chevron-right' : 'bx bx-chevron-left')" class="icon icon-collapse desplegable"
        ></i>
      </a>
    </li>
    @if (hasChildrens) {
      <div
        style="padding-left: 5px;"
        #collapseBasic
        [collapse]="!menuItem.isCollapsed"
        [isAnimated]="true"
        >
        <div
          class="well well-lg card card-block card-header item-directory"
          >
          @for (children of menuItem.children; track children) {
            <app-menu-item
              [menuItem]="children"
              [flagSidebar]="flagSidebar"
              [isChildren]="true"
              (clickEmit)="getClick($event)"
              (onAccionMiniNav)="getOnAccionMiniNav($event)"
            ></app-menu-item>
          }
        </div>
      </div>
    }
  </ul>
}


